<template>
    <div id="modal_popup_details" class="modal-popup">
      <div class="modal-popup-content">
        <a
          onclick="document.getElementById('modal_popup_details').style.visibility = 'hidden'"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.complaintDetails" class="d-flex flex-column">
          <div class="d-flex flex-row justify-content-between">
            <p >
              <strong>{{ $t("keyLabel") }} : &nbsp;&nbsp;</strong>
              <span>              <a :href="'https://upromania.atlassian.net/browse/' + this.complaintDetails.key" target="_blank"> {{ this.complaintDetails.key }} </a>
            </span>
            </p>
            <p >
              <strong>{{ $t("statusLabel") }} : &nbsp;&nbsp;</strong>
              <span>{{ this.complaintDetails.status }} </span>
            </p>
          <p >
            <strong>{{ $t("titleLabel") }} : &nbsp;&nbsp;</strong>
            <span>{{ this.complaintDetails.title }}</span>
          </p>
        </div>
          <div class="d-flex flex-row justify-content-between">
                    <p >
            <strong>{{ $t("cardidLabel") }} : &nbsp;&nbsp;</strong>
            <span>{{ complaintDetails.user_data ? complaintDetails.user_data.card.card_id : "" }}</span>
          </p>
          <p >
            <strong>{{ $t("beneficiariesFilterCardType") }} : &nbsp;&nbsp;</strong>
            <span>{{ this.complaintDetails.user_data ? this.complaintDetails.user_data.card.type : "" }} </span>
          </p>
          <p >
            <strong>{{ $t("beneficiariesFilterCardStatus") }} : &nbsp;&nbsp;</strong>
            <span> {{ this.complaintDetails.user_data ? $t('cardStatus_' + this.complaintDetails.user_data.card.status) : "" }}</span>
          </p>
          <p >
            <strong>{{ $t("soldLabel") }} &nbsp;&nbsp;</strong>
            <span>{{ this.complaintDetails.user_data ? this.complaintDetails.user_data.card.balance : "" }}</span>
          </p>
          <p >
            <strong>{{ $t("lastFourPAN") }} : &nbsp;&nbsp;</strong>
            <span>{{ this.complaintDetails.user_data ? this.complaintDetails.user_data.card.card_last_digits : "" }}</span>
          </p>

        </div>
       
          <div class="d-flex flex-row justify-content-between">
              <p >
                <strong>{{ $t("beneficiariesTableCNP") }} : &nbsp;&nbsp;</strong>
                <span class="culoare-12">{{ this.complaintDetails.user_data ? this.complaintDetails.user_data.cnp : "" }}</span>
              </p>
              <p >
                <strong>{{ $t("beneficiariesTableNameAndSurname") }} : &nbsp;&nbsp;</strong>
                <span>{{ this.complaintDetails.user_data ? this.complaintDetails.user_data.first_name + " " + this.complaintDetails.user_data.last_name : "" }}</span>
              </p>
                            <p >
                <strong>{{ $t("phoneBOULabel") }} : &nbsp;&nbsp;</strong>
                <span class="culoare-12">{{ complaintDetails.user_data ? complaintDetails.user_data.phone : "" }}</span>
              </p>
               <p >
                <strong>{{ $t("phoneJiraLabel") }} : &nbsp;&nbsp;</strong>
                <span class="culoare-12">{{ complaintDetails.phone ? complaintDetails.phone : "" }}</span>
              </p>
              </div>
               <div class="d-flex flex-row justify-content-between">
          <p >
            <strong>{{ $t("codallLabel") }} : &nbsp;&nbsp;</strong>
            <span>{{ this.complaintDetails.user_data ? this.complaintDetails.user_data.employer.codhd : "" }}</span>
          </p>
          <p >
            <strong>{{ $t("searchByCompanyName") }} : &nbsp;&nbsp;</strong>
            <span>{{ this.complaintDetails.user_data ? this.complaintDetails.user_data.employer.name : "" }}</span>
          </p>
                        </div>
          <div class="d-flex flex-row justify-content-between">
                                          <p >
                <strong>{{ $t("beneficiariesTableDateCreated") }} : &nbsp;&nbsp;</strong>
                <!-- <span>{{ complaintDetails.created ? displayDateTime(complaintDetails.created) : "" }}</span> -->
                <span>{{ complaintDetails.created ? complaintDetails.created : "" }}</span>
              </p>
                                          <p >
                <strong>{{ $t("jiraUserLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.jira_user ? complaintDetails.jira_user : "" }}</span>
              </p>       
              </div>       
              <p class='overflow'>
                <strong>{{ $t("descriptionLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.description }}</span>
              </p>
              <div class="d-flex flex-row justify-content-between border-top">
                <!-- // comentarii -->
                 <p >
                <strong>{{ $t("jiraCommentsTitle") }} &nbsp;&nbsp;</strong>
              </p>
              </div>
              <div class="d-flex flex-row justify-content-between">
                 <p v-if="!jiraCommentsLoaded">
                <span >              
                  <a class="cursor-pointer"  @click="getComplaintComments()"> {{ $t("showJiraComments") }} </a>
                  <img style="width: 50px;" v-if="jiraCommentsLoading" src="@/assets/images/loading.gif" />
                  </span></p>
                  <table v-else width="100%">
                    <thead>
                      <tr>
                        <td valign="middle">
                          <strong>{{ $t("keywordFilter") }}</strong>
                        </td>
                        <td valign="middle">
                          <strong>{{ $t("beneficiariesTableDateCreated") }}</strong>
                        </td>
                        <td valign="middle">
                          <strong>{{ $t("createdByLabel") }}</strong>
                        </td>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(comment, index) in jiraComments">
                          <tr
                            :key="index"
                            class="trhover parent"
                            :class="index % 2 === 0 && 'gri-cell'"
                          >
                            <td valign="middle">
                              {{ comment.description }}
                            </td>
                            <td valign="middle">
                              {{ comment.created_at }}
                            </td>
                            <td valign="middle">
                              {{ comment.created_by }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                  </table>
              </div > 
              <div class="d-flex flex-row justify-content-between border-top">
                <!-- // comentarii -->
                 <p >
                <strong>{{ $t("notesTitle") }} &nbsp;&nbsp;</strong>
              </p>
              </div>
              <div class="d-flex flex-row justify-content-between">
                 <p v-if="!notesLoaded">
                <span >              
                  <a class="cursor-pointer"  @click="getComplaintNotes()"> {{ $t("showNotes") }} </a>
                  <img style="width: 50px;" v-if="notesLoading" src="@/assets/images/loading.gif" />
                  </span></p>
                  <table v-else width="100%">
                    <thead>
                      <tr>
                        <td valign="middle">
                          <strong>{{ $t("keywordFilter") }}</strong>
                        </td>
                        <td valign="middle">
                          <strong>{{ $t("beneficiariesTableDateCreated") }}</strong>
                        </td>
                        <td valign="middle">
                          <strong>{{ $t("createdByLabel") }}</strong>
                        </td>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(comment, index) in notes">
                          <tr
                            :key="index"
                            class="trhover parent"
                            :class="index % 2 === 0 && 'gri-cell'"
                          >
                            <td valign="middle">
                              {{ comment.description }}
                            </td>
                            <td valign="middle">
                              {{ comment.created_at }}
                            </td>
                            <td valign="middle">
                              {{ comment.created_by }}
                            </td>
                            </tr>
                            </template>
                            </tbody>
                  </table>
              </div> 
        </div>
      </div>
    </div>
</template>
<script>
  import moment from "moment";
  import Cookies from "js-cookie";
  import httpServiceBenef from "@/http/http-ben-support.js";


  export default {
    name: "ComplaintInfoPopup",
    props: {
      complaintDetails: Object,
      msg: String,
    },
    data() {
      return {
        detailsMobile: false,
        complaintSelectedMobile: null,
        transactionError: null,
        jiraCommentsLoading: false,
        jiraCommentsLoaded: false,
        jiraComments: null,
        notesLoading: false,
        notesLoaded: false,
        notes: null,
      };
    },
    methods: {
      displayDate(date) {
        return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format(
          "DD/MM/YYYY"
        );
      },
      displayDateTime(date) {
        return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format(
          "DD/MM/YYYY HH:mm"
        );
      },
      getComplaintComments() {
        this.jiraCommentsLoading = true;
        this.jiraCommentsLoaded = false;
        httpServiceBenef.beneficiariesService
          .getComplaintComments(
            this.complaintDetails.id,
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false);
          })
          .then((response) => {
            if (response.status == 200) {
              this.jiraComments = response.data;
              this.jiraCommentsLoaded = true;
            } else if (response.status == 400 || response.status == 403) {
              this.jiraComments = [];
            }
            this.jiraCommentsLoading = false;
          });
      },
      getComplaintNotes() {
        this.notesLoading = true;
        this.notesLoaded = false;
        httpServiceBenef.beneficiariesService
          .getComplaintNotes(
            this.complaintDetails.id,
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false);
          })
          .then((response) => {
            if (response.status == 200) {
              this.notes = response.data;
              this.notesLoaded = true;
            } else if (response.status == 400 || response.status == 403) {
              this.notes = [];
            }
            this.notesLoading = false;
          });
      },
      
      modifyComplaintNote() {
        this.showModalPopup("modal_popup_loading", true);
        httpServiceBenef.beneficiariesService
          .putComplaintNotes(
            this.selectedComplaint.id,
            {id: this.selectedComplaint.id,
              description: "text",
            },
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false);
          })
          .then((response) => {
            if (response.status == 200) {
            } else if (response.status == 400 || response.status == 403) {
              this.noteError = {code: 500}
            }
            this.showModalPopup("modal_popup_loading", false);
          });
      },
    },
    watch : {
      complaintDetails: {
        handler: function (val) {
          this.jiraComments = null;
          this.jiraCommentsLoaded = false;
          this.notes = null;
          this.notesLoaded = false;
        }
      }
    },
    mounted() {
      localStorage.removeItem("selected_beneficiary");
    }
  };
</script>
<style scoped>
  #modal_popup_details .modal-popup-content {
    text-align: left !important;
    max-width: 60% !important;
    width: 60%;
  }

  .invoices-table {
    padding: 1px;
  }

  .overflow {
    overflow-wrap: break-word;
  }

  .max-width-230 {
    max-width: 230px;
  }

  p {
    margin: 5px !important;
  }

  .border-top {
    border-top: 1px solid grey;
    margin-top: 15px;
  }

  .hover-table tr.trhover:hover a,
  .hover-table tr.trhover:hover a:hover {
    color: #fff;
  }

</style>
<style scoped src="@/assets/styles/beneficiary.css"></style>
